<template>
  <img src="@/assets/img/loading.gif" class="loading-small" v-show="visible" />
</template>

<script>
import { EventBus } from "@/eventHub.js";

export default {
  name: "loading-small",
  data() {
    return {
      visible: false
    };
  },
  created() {
    EventBus.$on("showLoadingSmall", () => {
      this.visible = true;
    });

    EventBus.$on("hideLoadingSmall", () => {
      this.visible = false;
    });
  }
};
</script>

<style lang="scss" scoped>
.loading-small {
  width: 36px;
  position: absolute;
}
</style>
